import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import RoutePage from './components/routes/index';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    return (
        <Fragment>
            <RoutePage />
            <ToastContainer />
        </Fragment>
    );
}

export default App;
